import type { BusinessUnitSolutionsWeb2CaseFormValues } from './BusinessUnitSolutionsWeb2CaseForm.schema';

export const INITIAL_VALUES: BusinessUnitSolutionsWeb2CaseFormValues = {
  first_name: '',
  last_name: '',
  company: '',
  postal_code: '',
  street: '',
  city: '',
  phone: '',
  email: '',
  customer_type: undefined,
  question: undefined,
  message: undefined,
  chargepilot_site: undefined,
  manufacturer: undefined,
  serial_number: undefined,
  old_serial_number: undefined,
  new_serial_number: undefined,
  relevant_area: undefined,
  is_station_online: undefined,
  'g-recaptcha-response': '',
};
